import { createFeatureSelector } from '@ngrx/store';
import { Map } from 'immutable';

import { Loadable } from '®shared/data';
import { Section } from '®shared/reading-list/models';

export const STATE_FEATURE_SECTION_RESOLVER_STORE = 'sectionResolverStore';

export type LoadableSection = Loadable<Section>;
export type SectionsById = Map<string, LoadableSection>;

export type SectionResolverStoreState = {
  draftSectionsById: SectionsById;
  publishedSectionsById: SectionsById;
};

export const SECTIONS_BY_ID_INITIAL_STATE: SectionsById = Map<
  string,
  LoadableSection
>();
export const SECTION_RESOLVER_STORE_INITIAL_STATE: SectionResolverStoreState = {
  draftSectionsById: SECTIONS_BY_ID_INITIAL_STATE,
  publishedSectionsById: SECTIONS_BY_ID_INITIAL_STATE,
};

export function getInitialSectionResolverStoreState(): SectionResolverStoreState {
  return SECTION_RESOLVER_STORE_INITIAL_STATE;
}

export const selectSectionResolverStoreState =
  createFeatureSelector<SectionResolverStoreState>(
    STATE_FEATURE_SECTION_RESOLVER_STORE,
  );
